import {backHrefQuery} from "shared/utils/back_url_generator";

function backHrefQueryFilter() {
    return function (url) {
        return backHrefQuery(url);
    }
}

export default backHrefQueryFilter